import { GlobeAltIcon } from '@heroicons/react/outline';
import { Dropdown, Menu } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import Briefcase from 'assets/Icons/Briefcase';
import NewTextIcon from 'assets/Icons/NewTextIcon';
import PhoneHeaderIcon from 'assets/Icons/PhoneHeaderIcon';
import Link from 'next/link';
import React, { FC, useEffect, useRef, useState } from 'react';
import { BiChevronDown } from 'react-icons/bi';
import { twMerge } from 'tailwind-merge';

import { montserrat } from '@/components/Layout';
import {
  OptionLinksEnum,
  OptionsEnum,
} from '@/components/Layout/Header/Search';

interface Props {
  className?: string;
  isSecondRowHidden: boolean;
}
const ContactDropdown: FC<Props> = ({ className, isSecondRowHidden }) => {
  const screens = useBreakpoint();
  const [visible, setVisible] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setVisible(false);
  }, [isSecondRowHidden]);
  const menu = (
    <Menu
      className='bg-cartBgColor border border-[#282829] w-fit rounded-xl overflow-hidden'
      style={{ width: 240 }}
      items={[
        {
          key: '1',
          label: (
            <Link
              onClick={(e) => {
                e.stopPropagation();
              }}
              href={OptionLinksEnum.CONTACT}
              className='text-white'
            >
              <div className='flex items-center py-2'>
                <span className='pr-2'>
                  {' '}
                  <PhoneHeaderIcon />
                </span>

                <span className='font-medium text-sm'>
                  {OptionsEnum.CONTACT}
                </span>
              </div>
            </Link>
          ),
        },
        {
          key: '2',
          label: (
            <Link
              onClick={(e) => {
                e.stopPropagation();
              }}
              href={OptionLinksEnum.PARTNERSHIP}
              className='text-white'
            >
              <div className='flex items-center py-2'>
                <span className='flex items-center justify-center w-5 h-5 mr-2'>
                  <Briefcase />
                </span>
                <span className='font-medium pr-2 text-sm'>
                  {OptionsEnum.PARTNERSHIP}
                </span>
                <span
                  style={{
                    background:
                      'linear-gradient(180deg, #F9742C 0%, #F20486 100%)',
                  }}
                  className=' px-2 py-1 text-xs font-bold text-white rounded-full'
                >
                  <NewTextIcon />
                </span>
              </div>
            </Link>
          ),
        },
        {
          key: '3',
          label: (
            <Link
              onClick={(e) => {
                e.stopPropagation();
              }}
              href={OptionLinksEnum.PUBLIHS_WITH_US}
              className='text-white'
            >
              <div className='flex items-center py-2'>
                <GlobeAltIcon className='h-5 w-5 mr-2' />
                <span className='font-medium'>
                  {OptionsEnum.PUBLIHS_WITH_US}
                </span>
              </div>
            </Link>
          ),
        },
      ]}
    />
  );

  return (
    <div className='flex items-center justify-end space-x-2' ref={dropdownRef}>
      <Dropdown
        overlay={menu}
        trigger={[screens.lg ? 'hover' : 'click']}
        overlayClassName='dropdown-dark'
        placement='bottomRight'
        open={visible}
        onOpenChange={(v) => setVisible(v)}
        overlayStyle={{
          fontFamily: montserrat.style.fontFamily,
        }}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
          }}
          className={twMerge(
            'sm:hidden flex items-center gap-2 h-10 border-[1.5px]  border-grayZl-850  rounded-r-xl  px-3 lg:mb-0 sm:mb-2 mb-3 ',
            'hover:bg-grayZl-900 hover:scale-105 active:bg-grayZl-900 active:scale-95 transition-all ',
            className,
          )}
        >
          <p className='text-sm text-[22px] text-white'>Contact</p>
          <BiChevronDown className='w-6 h-6 text-white' />
        </button>
      </Dropdown>
    </div>
  );
};

export default ContactDropdown;
